'use client';

import { KeyboardArrowDownIcon } from '../icons';

export type DetailsToggleButtonProps = {
  expanded: boolean;
  onClick: () => void;
  controlsId: string;
};

export function DetailsToggleButton({ expanded, onClick, controlsId }: DetailsToggleButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-expanded={expanded}
      aria-controls={controlsId}
      className="inline-flex items-center gap-1 px-1 py-0.5 text-xs font-bold tracking-[0.5px] text-[var(--content-green-dark)] uppercase hover:underline focus-visible:rounded-[4px] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
    >
      {expanded ? 'Less Details' : 'More Details'}
      <KeyboardArrowDownIcon
        className={`size-4 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
      />
    </button>
  );
}
